import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  background-color: rgba(93, 10, 10, 0.31);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpinnerUI = styled.div`
  border: 3px solid ${({ theme }) => theme.colors.gray50};
  border-radius: 50%;
  border-top: 3px solid ${({ theme }) => theme.colors.primaryGreen500};
  width: 22px;
  height: 22px;
  -webkit-animation: spin 1.5s linear infinite; /* Safari */
  animation: spin 1.5s linear infinite;
  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
